import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input } from 'antd';

export interface SmsTemplateEditModalProps extends PopupProps {
    item: SmsTemplateDto;
}

const SmsTemplateEditModal = ({ isOpen, onClose, item }: SmsTemplateEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

    /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        onClose?.(true, {id: item.id, title: e.title, subject: e.subject, content: e.content});
      };
   
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            title: item.title,
            subject: item.subject,
            content: item.content,
        });
    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={450} title={`문자 템플릿 ${item.id > 0?'수정':'등록'}`} closable>
            <Form
                form={form}
                name="saleRate"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="title" label={'템플릿명'} rules={[{ required: true, message: '' }]}>
                    <Input type={'text'} placeholder='제목을 입력하세요' />
                </Form.Item>   
                <Form.Item name="subject" label={'제목'} rules={[{ required: true, message: '' }]}>
                    <Input type={'text'} placeholder='제목을 입력하세요' />
                </Form.Item>                                   
                <Form.Item name="content" label={'내용'} rules={[{ required: true, message: '' }]}>
                    <TextArea rows={15} placeholder='내용을 입력하세요'/>                    
                </Form.Item>                              
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary">{'저장'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(SmsTemplateEditModal);    